import React from "react";
import { Form, Formik } from "formik";
import { Redirect, useHistory } from "react-router-dom";

import ROUTES from "@config/routes";
import Layout from "@components/Layout";
import Title from "@components/Title";

import UserForm from "../shared/ui/UserForm";
import FormEditUserValidationSchema from "./validation";
import { useSubmitEditUser } from "./useSubmitEditUser";

const EditUserPage: React.FC = () => {
  const history = useHistory();
  const { loading, initialValues, handleSubmit, hasUser } = useSubmitEditUser();

  if (!hasUser) {
    return <Redirect to={ROUTES.ADMIN_ROUTES.HOME} />;
  }

  if (!initialValues) {
    return (
      <Layout>
        <div style={{ gridArea: "content" }}>
          <Title title="Editar Usuário" />
          <div style={{ textAlign: "center", padding: "2rem" }}>
            Carregando...
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div style={{ gridArea: "content" }}>
        <Title title="Editar Usuário" />
        <Formik
          initialValues={initialValues}
          validationSchema={FormEditUserValidationSchema}
          onSubmit={handleSubmit}
        >
          <Form style={{ margin: "0" }}>
            <UserForm
              loading={loading}
              title="Dados do usuário"
              submitLabel="Salvar"
              submitLoadingLabel="Salvando..."
              onCancel={() => history.push(ROUTES.ADMIN_ROUTES.LIST_USERS)}
            />
          </Form>
        </Formik>
      </div>
    </Layout>
  );
};

export default EditUserPage;
